"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledTableCell = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

var _consts = _interopRequireDefault(require("./consts"));

var _rtl = require("../../utils/rtl");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var StyledTableCell = (0, _styledComponents.default)(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTest = _ref.dataTest;
  return React.createElement("td", {
    className: className,
    "data-test": dataTest
  }, children);
}).withConfig({
  displayName: "TableCell__StyledTableCell",
  componentId: "sc-1dr7ow2-0"
})(["box-sizing:border-box;font-family:", ";font-size:", ";color:", ";text-align:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.colorTextTable;
}, function (_ref5) {
  var align = _ref5.align;
  return (0, _rtl.textAlign)(align);
});
exports.StyledTableCell = StyledTableCell;
StyledTableCell.defaultProps = {
  theme: _defaultTheme.default
};

var TableCell = function TableCell(_ref6) {
  var _ref6$align = _ref6.align,
      align = _ref6$align === void 0 ? _consts.default.CENTER : _ref6$align,
      dataTest = _ref6.dataTest,
      children = _ref6.children;
  return React.createElement(StyledTableCell, {
    align: align,
    dataTest: dataTest
  }, children);
};

var _default = TableCell;
exports.default = _default;